// extracted by mini-css-extract-plugin
export default {"container":"PurchaseConfirmation_container__RC8J-"};